export const RESET = 'EXCMDEVICEPERIPHERAL_LIST_RESET'
export const SET_ITEMS = 'EXCMDEVICEPERIPHERAL_LIST_SET_ITEMS'
export const SET_ERROR = 'EXCMDEVICEPERIPHERAL_LIST_SET_ERROR'
export const SET_VIEW = 'EXCMDEVICEPERIPHERAL_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'EXCMDEVICEPERIPHERAL_LIST_TOGGLE_LOADING'
